import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image"

import CustomBadge from "../badges/CustomBadge"
import Price from "../shopifyProduct/Price"
import classNames from "classnames"

export interface IProductCardProps {
  /**
   * Product title
   */
  title: string
  /**
   * Micro description displayed on the product tile
   */
  microDescription?: string
  /**
   * Price
   */
  price: number
  /**
   * Original price if on sale
   */
  compareAtPrice: number
  /**
   * Link to the product single page
   */
  url: string
  /**
   * Badge to display
   */
  badge?: {
    /**
     * label
     */
    label: string
    /**
     * background color
     */
    backgroundColor?: string
    /**
     * enabled
     */
    enabled?: boolean
  }

  /**
   * gatsbyImageData
   */
  featuredImage?: {
    image: {
      altText?: string
      gatsbyImageData?: IGatsbyImageData
    }
  }

  className?: string
}

const ProductCard = ({
  title,
  microDescription,
  price,
  url,
  badge,
  compareAtPrice,
  featuredImage,
  className,
}: IProductCardProps) => {
  return (
    <Link
      to={url}
      className={classNames(
        "mx-[8px] mt-[5px] mb-[20px] flex min-h-[443px] flex-col items-center rounded bg-white p-[15px] text-center hover:drop-shadow-custom1",
        className
      )}
    >
      <div className="flex h-[231px] w-full items-center">
        {featuredImage?.image?.gatsbyImageData && (
          <div className="w-[90%] md:w-full">
            <GatsbyImage
              image={featuredImage?.image?.gatsbyImageData}
              alt={featuredImage?.image?.altText || ""}
              objectFit={"contain"}
              className="max-h-[231px]"
            />
          </div>
        )}
      </div>
      <div className="my-[10px] h-[28px]">
        {badge?.enabled && <CustomBadge {...badge} />}
      </div>
      {title && (
        <div className="mb-1 pt-[10px] pb-[5px] text-subTitle2 font-semibold text-darkGrey">
          {title}
        </div>
      )}

      {microDescription && (
        <p className=" text-body2 text-darkBlue">{microDescription}</p>
      )}

      <div className="relative mt-auto h-[25px]">
        <Price price={price} compareAtPrice={compareAtPrice} />
      </div>
    </Link>
  )
}

export default ProductCard
